import { IMG } from '../../const';

const BannerVideo = () => {
  return (
    <video
      src={`${IMG.QUICK_QUOTE}/video/fill-form.mp4`}
      autoPlay
      playsInline
      controls
    ></video>
  );
};

export default BannerVideo;
